import flatpickr from "flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es.js"

const getDisabledDatesByDays = (days) => {
  if (!days)
    return []

  const today = new Date()
  const untilDate = today.setDate(today.getDate() + parseInt(days))

  return [{
    from: 'today',
    to: untilDate
  }]
}

const date = ($pickrs) => {
  $pickrs.forEach(($pickr) => {
    // const disableDates = getDisabledDatesByDays($pickr.getAttribute('minDays'))
    const createdAtMeta = document.head.querySelector('meta[name="created_at"]')
    const createdAt = (createdAtMeta && !$pickr.getAttribute('birthday') ) ? createdAtMeta.content : null
    const disableMobile = $pickr.getAttribute('birthday') ? true : false

    flatpickr($pickr, {
      allowInput: false,
      altFormat: 'd/m/Y',
      altInput: true,
      animate: false,
      dateFormat: 'Ymd',
      // disable: disableDates,
      minDate: createdAt || '',
      maxDate: "today",
      locale: {
        ...(app.locale === 'es') ? Spanish : null,
        firstDayOfWeek: 1
      },
      disableMobile: disableMobile,
    })
  })
}
const time = ($pickrs) => {
  $pickrs.forEach(($pickr) => {
    flatpickr($pickr, {
      allowInput: false,
      altFormat: 'h:i',
      altInput: true,
      animate: false,
      dateFormat: "Hi",
      enableTime: true,
      noCalendar: true,
      // minDate: $pickr.getAttribute('minDate') || null,
      time_24hr: true,
      locale: {
        ...(app.locale === 'es') ? Spanish : null,
        firstDayOfWeek: 1
      },
      onOpen: (selectedDates, dateStr, instance) => {
        instance.element.value = '12:00'
        instance.element.dispatchEvent(new Event('change'))
      },
    })
  })
}
const dateTime = ($pickrs) => {
  $pickrs.forEach(($pickr) => {
    // const disableDates = getDisabledDatesByDays($pickr.getAttribute('minDays'))

    flatpickr($pickr, {
      allowInput: false,
      altFormat: 'd/m/Y H:i',
      altInput: true,
      animate: false,
      enableTime: true,
      dateFormat: 'YmdHi',
      // disable: disableDates,
      // minDate: $pickr.getAttribute('minDate') || null,
      time_24hr: true,
      locale: {
        ...(app.locale === 'es') ? Spanish : null,
        firstDayOfWeek: 1
      }
    })
  })
}

class flatpickrInput {
  constructor() {
    this.dom = {
      flatpickr: document.querySelectorAll('input[type="flatpickr"]'),
      flatpickrDateTime: document.querySelectorAll('input[type="flatpickrDateTime"]'),
      flatpickrTime: document.querySelectorAll('input[type="flatpickrTime"]'),
    }
  }
  init() {
    if (this.dom.flatpickr)
      date(this.dom.flatpickr)

    if (this.dom.flatpickrTime)
      time(this.dom.flatpickrTime)

    if (this.dom.flatpickrDateTime)
      dateTime(this.dom.flatpickrDateTime)
  }
}

export default flatpickrInput
